<template>
  <el-dialog :destroy-on-close="true" ref="dialog" :title="title" :visible="dialogVisible" @opened="opened"
    :before-close="close">
    <slot name="default"></slot>
    <div class="top-box">
      <div class="item">
        <div class="label">温度</div>
        <div class="value">20.5℃</div>
      </div>
      <!-- <div class="item">
        <div class="label">湿度</div>
        <div class="value">60%~80%</div>
      </div> -->
      <div class="item">
        <div class="label">氮含量</div>
        <div class="value">0.0046%</div>
      </div>
      <div class="item">
        <div class="label">磷含量</div>
        <div class="value">0.0046%</div>
      </div>
      <div class="item">
        <div class="label">钾含量</div>
        <div class="value">0.0046%</div>
      </div>
      <div class="item">
        <div class="label">PH值</div>
        <div class="value">7.5</div>
      </div>
    </div>
    <div class="map-box" id="mapChart"></div>
    <div class="corn1">
      <div class="content">
        <div class="txt">
          <span>温度：</span>
          <span>20.5℃</span>
        </div>
        <div class="txt">
          <span>氮含量：</span>
          <span>0.005%</span>
        </div>
        <div class="txt">
          <span>磷含量：</span>
          <span>0.004%</span>
        </div>
        <div class="txt">
          <span>钾含量：</span>
          <span>0.0041%</span>
        </div>
        <div class="txt">
          <span>PH值：</span>
          <span>7.5</span>
        </div>
      </div>
    </div>
    <div class="corn2">
      <div class="content">
        <div class="txt">
          <span>温度：</span>
          <span>20.5℃</span>
        </div>
        <div class="txt">
          <span>氮含量：</span>
          <span>0.0047%</span>
        </div>
        <div class="txt">
          <span>磷含量：</span>
          <span>0.0046%</span>
        </div>
        <div class="txt">
          <span>钾含量：</span>
          <span>0.0041%</span>
        </div>
        <div class="txt">
          <span>PH值：</span>
          <span>7.5</span>
        </div>
      </div>
    </div>
    <div class="corn3">
      <div class="content">
        <div class="txt">
          <span>温度：</span>
          <span>20.1℃</span>
        </div>
        <div class="txt">
          <span>氮含量：</span>
          <span>0.0056%</span>
        </div>
        <div class="txt">
          <span>磷含量：</span>
          <span>0.0048%</span>
        </div>
        <div class="txt">
          <span>钾含量：</span>
          <span>0.0041%</span>
        </div>
        <div class="txt">
          <span>PH值：</span>
          <span>7.5</span>
        </div>
      </div>
    </div>
    <div class="corn4">
      <div class="content">
        <div class="txt">
          <span>温度：</span>
          <span>20.6℃</span>
        </div>
        <div class="txt">
          <span>氮含量：</span>
          <span>0.0049%</span>
        </div>
        <div class="txt">
          <span>磷含量：</span>
          <span>0.0043%</span>
        </div>
        <div class="txt">
          <span>钾含量：</span>
          <span>0.0041%</span>
        </div>
        <div class="txt">
          <span>PH值：</span>
          <span>7.5</span>
        </div>
      </div>
    </div>
    <div class="corn5">
      <div class="content">
        <div class="txt">
          <span>温度：</span>
          <span>20.6℃</span>
        </div>
        <div class="txt">
          <span>氮含量：</span>
          <span>0.0049%</span>
        </div>
        <div class="txt">
          <span>磷含量：</span>
          <span>0.0043%</span>
        </div>
        <div class="txt">
          <span>钾含量：</span>
          <span>0.0041%</span>
        </div>
        <div class="txt">
          <span>PH值：</span>
          <span>7.5</span>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import mapJson from '../../../../assets/map/redRiver.json'
export default {
  props: {
    title: {
      type: String,
      default: '伊金霍洛旗',
    },
    dialogVisible: {
      type: Boolean,
      default: true,
    },
    modelParams: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      activeValue: '0',
      mapData: [
        {
          name: '纳林陶亥镇',
          value: [110.11966302149337, 39.6283242456816],
        },
      ],
      regions: [
        {
          name: '红庆河镇',
          itemStyle: { color: 'rgba(26, 87, 86, 0.4)' },
        },
        {
          name: '纳林陶亥镇',
          itemStyle: { color: 'rgba(17, 45, 109, 1)' },
        },
      ],
    }
  },
  /*  mounted() {
    const mapData = [
      {
        name: '纳林陶亥镇',
        value: [110.11966302149337, 39.6283242456816],
      },
    ]
    const regions = [
      {
        name: '红庆河镇',
        itemStyle: { color: 'rgba(26, 87, 86, 0.4)' },
      },
      {
        name: '纳林陶亥镇',
        itemStyle: { color: 'rgba(17, 45, 109, 1)' },
      },
    ]
  }, */
  watch: {
    dialogVisible(n) {
      console.log('iiiii', n)
      if (n) {
        this.$nextTick(() => {
          this.draw(this.mapData, this.regions)
        })
      }
    },
  },
  mounted() { },
  async created() {
    console.log('mmkmmkmkmkmk')
  },

  methods: {
    close() {
      this.$parent.dialogVisible = false
    },
    opened() {
      console.log(999)
      this.$emit('opened')
    },
    draw(data, regions) {
      this.$echarts.init(document.getElementById('mapChart')).dispose()
      const _this = this
      // 基于准备好的dom，初始化echarts实例
      var chart = this.$echarts.init(document.getElementById('mapChart'))

      this.$echarts.registerMap('bayannaoer', mapJson)
      // 隐藏动画加载效果。
      chart.hideLoading()

      let cahrtOption = {
        geo3D: {
          silent: false,
          type: 'map3D', // 系列类型
          name: 'map3D', // 系列名称
          map: 'bayannaoer',
          boxHeight: 4,
          zoom: 1,
          label: {
            // 标签的相关设置
            show: false, // (地图上的城市名称)是否显示标签 [ default: false ]
            //distance: 50, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离
            //formatter:, // 标签内容格式器
            textStyle: {
              // 标签的字体样式
              color: '#000', // 地图初始化区域字体颜色
              fontSize: 8, // 字体大小
              opacity: 1, // 字体透明度
              backgroundColor: 'rgba(0,23,11,0)', // 字体背景色
            },
          },

          itemStyle: {
            // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
            color: 'rgba(51, 119, 171, 0.3)', // 地图板块的颜色
            opacity: 1, // 图形的不透明度 [ default: 1 ]
            borderWidth: 2, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
            borderColor: 'rgba(111,202,242, 0.8)', // 图形描边的颜色。[ default: #333 ]
          },

          emphasis: {
            // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
            label: {
              // label高亮时的配置
              show: false,
              textStyle: {
                color: '#fff', // 高亮时标签颜色变为 白色
                fontSize: 15, // 高亮时标签字体 变大
              },
              borderColor: '#08DAC8',
              borderWidth: 2,
              padding: 5,
              backgroundColor: 'red',
              extraCssText: 'box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;',
              formatter: function (params) {
                return params.name + '\n' + 'Clicked!'
              },
            },
          },

          groundPlane: {
            // 地面可以让整个组件有个“摆放”的地方，从而使整个场景看起来更真实，更有模型感。
            show: false, // 是否显示地面。[ default: false ]
          },
          light: {
            // 光照相关的设置。在 shading 为 'color' 的时候无效。 光照的设置会影响到组件以及组件所在坐标系上的所有图表。合理的光照设置能够让整个场景的明暗变得更丰富，更有层次。
            main: {
              // 场景主光源的设置，在 globe 组件中就是太阳光。
              color: '#fff', //主光源的颜色。[ default: #fff ]
              intensity: 1.2, //主光源的强度。[ default: 1 ]
              shadow: false, //主光源是否投射阴影。默认关闭。 开启阴影可以给场景带来更真实和有层次的光照效果。但是同时也会增加程序的运行开销。
              shadowQuality: 'high', // 阴影的质量。可选'low', 'medium', 'high', 'ultra' [ default: 'medium' ]
              alpha: 55, // 主光源绕 x 轴，即上下旋转的角度。配合 beta 控制光源的方向。[ default: 40 ]
              beta: 10, // 主光源绕 y 轴，即左右旋转的角度。[ default: 40 ]
            },
          },

          viewControl: {
            // 用于鼠标的旋转，缩放等视角控制。
            projection: 'perspective', // 投影方式，默认为透视投影'perspective'，也支持设置为正交投影'orthographic'。
            autoRotate: false, // 是否开启视角绕物体的自动旋转查看。[ default: false ]
            autoRotateDirection: 'cw', // 物体自传的方向。默认是 'cw' 也就是从上往下看是顺时针方向，也可以取 'ccw'，既从上往下看为逆时针方向。
            autoRotateSpeed: 10, // 物体自传的速度。单位为角度 / 秒，默认为10 ，也就是36秒转一圈。
            autoRotateAfterStill: 3, // 在鼠标静止操作后恢复自动旋转的时间间隔。在开启 autoRotate 后有效。[ default: 3 ]
            damping: 0, // 鼠标进行旋转，缩放等操作时的迟滞因子，在大于等于 1 的时候鼠标在停止操作后，视角仍会因为一定的惯性继续运动（旋转和缩放）。[ default: 0.8 ]
            rotateSensitivity: 0, // 旋转操作的灵敏度，值越大越灵敏。支持使用数组分别设置横向和纵向的旋转灵敏度。默认为1, 设置为0后无法旋转。 rotateSensitivity: [1, 0]——只能横向旋转； rotateSensitivity: [0, 1]——只能纵向旋转。
            zoomSensitivity: 0, // 缩放操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法缩放。
            panSensitivity: 0, // 平移操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法平移。支持使用数组分别设置横向和纵向的平移灵敏度
            panMouseButton: 'left', // 平移操作使用的鼠标按键，支持：'left' 鼠标左键（默认）;'middle' 鼠标中键 ;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
            rotateMouseButton: 'left', // 旋转操作使用的鼠标按键，支持：'left' 鼠标左键;'middle' 鼠标中键（默认）;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
            orthographicSize: 100,
            distance: 80, // [ default: 100 ] 默认视角距离主体的距离，对于 grid3D 和 geo3D 等其它组件来说是距离中心原点的距离,对于 globe 来说是距离地球表面的距离。在 projection 为'perspective'的时候有效。
            minDistance: 40, // [ default: 40 ] 视角通过鼠标控制能拉近到主体的最小距离。在 projection 为'perspective'的时候有效。
            maxDistance: 400, // [ default: 400 ] 视角通过鼠标控制能拉远到主体的最大距离。在 projection 为'perspective'的时候有效。

            alpha: 40, // 视角绕 x 轴，即上下旋转的角度。配合 beta 可以控制视角的方向。[ default: 40 ]
            beta: 0, // 视角绕 y 轴，即左右旋转的角度。[ default: 0 ]
            minAlpha: -45, // 上下旋转的最小 alpha 值。即视角能旋转到达最上面的角度。[ default: 5 ]
            maxAlpha: 45, // 上下旋转的最大 alpha 值。即视角能旋转到达最下面的角度。[ default: 90 ]
            minBeta: -45, // 左右旋转的最小 beta 值。即视角能旋转到达最左的角度。[ default: -80 ]
            maxBeta: 45, // 左右旋转的最大 beta 值。即视角能旋转到达最右的角度。[ default: 80 ]

            center: [0, 0, 0], // 视角中心点，旋转也会围绕这个中心点旋转，默认为[0,0,0]。

            animation: true, // 是否开启动画。[ default: true ]
            animationDurationUpdate: 1000, // 过渡动画的时长。[ default: 1000 ]
            animationEasingUpdate: 'cubicInOut', // 过渡动画的缓动效果。[ default: cubicInOut ]
          },
          regions: regions,
        },
        series: [
          {
            name: '纳林陶亥镇',
            // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
            type: 'scatter3D',
            coordinateSystem: 'geo3D',
            symbol:
              'path://M845.7 641h0.1l-0.1-21.1z,M362.7 666.4v-96.3c0-51.2-17-101.6-50.8-140.1-29-32.9-72.8-61.8-137.5-61.8 0 0 360.9-150 360.9 156.9v141.2-5.3 104.5S526.9 900 645.5 919.9c7.1 1.2 8 11 1.1 13.2-86.5 28.1-283.9 85-283.9-167.6V661.1v5.3z,M573.9 449.9c-25 10.5-39.8 34-38.5 58.8 0.3 5.3 0.4 10.8 0.4 16.5V765.6s-0.2 0.9-0.6 2.3c-0.5 17.1 0.5 133.3 109.8 152-1.8-29.9-25.3-477.4 204.5-415.8 0.1 0.1-145.9-108.9-275.6-54.2z,M625.3 159.1c0-0.2-0.1-0.2-0.1-0.3-36-94.6-109.7-93.9-109.7-93.9s-73.8-0.7-109.7 93.9c-0.1 0.2-0.1 0.2-0.1 0.3-0.8 2.7-17.5 58.1-27.1 171.8-0.1 0.8 0.3 1.4 0.6 2.1 68.6 6.4 132.3 39.5 150.8 133.1 5.8-7.2 13.2-13.2 22-17.2 28.9-13 58.6-16.3 86.9-13.9 4.7-0.3 9.5-0.4 14.2-0.4 1.1-1 2.2-1.9 3.7-3.2v-37.1c-7.9-156.8-30.6-232.2-31.5-235.2z,M656.6 397.9h-39.9v-50h37c-0.8-10.9-1.7-21.5-2.6-31.4h-34.4v-50h28.8c-1.5-11.3-3-21.9-4.5-31.4h-24.4v-50h15.1c-3.6-16.4-6.2-25-6.5-26 0-0.2-0.1-0.2-0.1-0.3-0.7-1.8-1.5-3.3-2.2-5.1h-6.3v-13.9c-20.2-40.2-47.6-58.9-68.9-67.5h-12.5v-4.2c-11.9-3.2-19.9-3.2-19.9-3.2s-4.4 0-11.5 1.3v6.2h-21c-18.4 7.5-41.5 22.6-60.5 52.6v28.8h-14.7c-0.7 1.7-1.5 3.3-2.2 5.1-0.1 0.2-0.1 0.2-0.1 0.3-0.3 1-2.9 9.6-6.5 26h23.5v50h-32.7c-1.5 9.5-3 20-4.5 31.4h37.2v50h-42.8c-0.4 4.7-0.9 9.4-1.3 14.4-0.1 0.8 0.3 1.4 0.6 2.1 26.5 2.5 52.2 9 74.9 21.3v-6.5h50v50h-1.6c12.4 18 22 40.4 27.5 68.2 1.6-2 3.6-3.7 5.5-5.5v-31.4h50v8.8c10.5-2.2 21-3.4 31.4-3.7v-5.1h39.9v-31.3z m-152.7-81.4h-50v-50h50v50z m0-81.4h-50v-50h50v50z m0-81.4h-50v-50h50v50z m81.4 244.2h-50v-50h50v50z m0-81.4h-50v-50h50v50z m0-81.4h-50v-50h50v50z m0-81.4h-50v-50h50v50z',
            symbolSize: 20,
            itemStyle: {
              normal: {
                color: '#FFF200',
              },
            },
            data: [
              {
                name: '红庆河镇',
                value: [109.20529833729624, 39.45334414691005, 100],
              },

              {
                name: '红庆河镇',
                value: [109.48529833729624, 39.40334414691005, 100],
              },
              {
                name: '红庆河镇',
                value: [109.52529833729624, 39.31334414691005, 100],
              },

              {
                name: '红庆河镇',
                value: [109.36529833729624, 39.30334414691005, 100],
              },
            ],
          },
          {
            name: '红庆河镇',
            // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
            type: 'scatter3D',
            coordinateSystem: 'geo3D',
            symbol: `path://M70.8 485.9l625.9 399.9 262.1-163.9-617.5-409.7z,M829.3 802.9L185.6 400.4l151.9-85.6 621.3 407.1z,M325.5 138.2l3.4 183 629.9 400.7 1.2-191.8z,M233.7 412.6l-132.1 83.9 11.8 11.1 138.5-85.2zM342.3 481.7l-132.1 84 11.8 11 138.4-85.2zM449 550.9l-132.1 83.9 11.8 11.1 138.4-85.2zM558.7 620.3l-132.1 83.9 11.8 11.1 138.5-85.2zM666.2 689.3l-132.1 83.9 11.8 11.1 138.4-85.2zM776.7 758.3l-132.1 84 11.8 11 138.4-85.2z,M120.4 498.2c0 5.4-5.3 9.4-11.8 9.4-6.5 0-11.8-3.8-11.8-11.1V341.8c0-7.2 23.6-5.6 23.6 1.6v154.8z,M119 348.9c-8.1-3.8-15.2-5.2-22.2-8.9v20.8c0 7.3 5.3 11.7 11.8 12.5 6.5 0.8 11.8-2.6 11.8-8v-15.8c-0.4-0.3-0.9-0.4-1.4-0.6z,M228.9 567.4c0 5.3-5.3 9.4-11.8 9.4-6.5 0-11.8-3.8-11.8-11.1V411c0-7.2 23.6-5.6 23.6 1.6v154.8z,M227.5 418c-8.1-3.8-15.2-5.2-22.2-8.9v20.8c0 7.2 5.3 11.7 11.8 12.4 6.5 0.8 11.8-2.6 11.8-8v-15.8c-0.4-0.1-0.9-0.3-1.4-0.5z,M337.5 636.6c0 5.4-5.3 9.4-11.8 9.4-6.5 0-11.8-3.9-11.8-11.1V480.1c0-7.2 23.6-5.6 23.6 1.6v154.9z,M336 487.2c-8.1-3.8-15.2-5.2-22.2-8.9v20.8c0 7.2 5.3 11.7 11.8 12.5 6.5 0.8 11.8-2.7 11.8-8v-15.8c-0.4-0.3-0.9-0.4-1.4-0.6z,M446 705.7c0 5.3-5.3 9.3-11.8 9.3-6.5 0-11.8-3.8-11.8-11.1V549.3c0-7.2 23.6-5.6 23.6 1.6v154.8z,M444.5 556.3c-8.1-3.8-15.2-5.2-22.2-8.9v20.8c0 7.2 5.3 11.7 11.8 12.5 6.5 0.7 11.8-2.6 11.8-8v-15.8c-0.4-0.2-0.9-0.3-1.4-0.6z,M554.5 774.9c0 5.3-5.3 9.3-11.8 9.3-6.5 0-11.8-3.8-11.8-11.1V618.4c0-7.2 23.6-5.6 23.6 1.6v154.9z,M553 625.5c-8.1-3.8-15.2-5.2-22.2-8.9v20.8c0 7.2 5.3 11.7 11.8 12.4 6.5 0.7 11.8-2.7 11.8-8V626c-0.4-0.2-0.9-0.3-1.4-0.5z,M663 844c0 5.3-5.3 9.4-11.8 9.4-6.5 0-11.8-3.8-11.8-11.1V687.6c0-7.2 23.6-5.6 23.6 1.6V844z,M661.5 694.6c-8.1-3.8-15.2-5.2-22.1-8.9v20.8c0 7.2 5.3 11.7 11.8 12.4 6.5 0.8 11.8-2.6 11.8-7.9v-15.8l-1.5-0.6z,M64 323.2l627.4 398.7L960 552.5v-22.4L325.5 138.2 64 299z,M64 299l625.9 400L960 530.1 325.5 138.2z,M910.2 564.1v188.2l48.6-30.4 1.2-191.8z`,
            symbolSize: 70,
            itemStyle: {
              normal: {
                color: '#ccc',
                areaColor: {
                  repeat: 'repeat',
                },
              },
            },
            data: [
              {
                name: '红庆河镇',
                value: [109.33305019089168, 39.43146024913993],
              },
              // {
              //   name: '红庆河镇',
              //   value: [109.37305019089168, 39.43146024913993],
              // },
              // {
              //   name: '红庆河镇',
              //   value: [109.37305019089168, 39.43146024913993],
              // },
            ],
          },
        ],
      }

      chart.setOption(cahrtOption)
      chart.getZr().on('click', (params) => {
        console.log(params)
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog {
  background: url('../../../../assets/yq/propertymodel.png');
  background-size: 100% 100%;
  box-shadow: 0px 0px 0.15rem 0px #00aeff inset;
  // width: 8.875rem !important;
  width: 12rem !important;

}

::v-deep .el-dialog__header {
  background: rgba(0, 174, 255, 0.59);
  height: 0.48rem;
  padding: 0 0.25rem;
  position: relative;
}

::v-deep .el-dialog__title {
  color: #00feff;
  font-size: 0.23rem;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  line-height: 0.48rem;
}

::v-deep .el-dialog__headerbtn {
  top: 50%;
  transform: translateY(-50%);
}

::v-deep .el-dialog__close {
  color: #fff !important;
}

::v-deep .el-dialog__body {
  padding: 0.375rem;
  height: 7.75rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.top-box {
  width: 100%;
  height: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .item {
    width: 15%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .label {
      font-size: 0.15rem;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
    }

    .value {
      font-size: 0.2rem;
      font-family: Impact-Regular, Impact;
      font-weight: 400;
      color: #00feff;
      margin: 0.0725rem 0;
    }
  }
}

.map-box {
  width: 100%;
  flex: 1;
}

.content {
  animation-name: FadeIn;
}

.corn1 {
  position: absolute;
  top: 3.2rem;
  left: 4.35rem;
  // width: 1rem;
  // height: 1rem;
  border-left: .03rem solid #00feff;
  border-top: .03rem solid #00feff;
  border-radius: 1%;
  // animation-delay: 1s;
  animation-duration: 1s;
  animation-direction: alternate;
  animation-name: FadeIn1;
  animation-fill-mode: forwards;

  .content {
    position: absolute;
    top: -0.5rem;
    left: 1.1rem;
    width: 1.5rem;
    height: 1.3rem;
    transform: scaleX(0);
    border: 1px dashed yellow;
    border-radius: 10%;
    animation-delay: 1s;
    animation-duration: 1s;
    animation-direction: alternate;
    animation-name: FadeIn11;
    animation-fill-mode: forwards;

  }
}

.corn2 {
  position: absolute;
  top: 3.5rem;
  left: 7.3rem;
  width: 0.3rem;
  height: 2rem;
  border-left: .03rem solid #00feff;
  border-top: .03rem solid #00feff;
  border-radius: 1%;
  animation-duration: 1s;
  animation-direction: alternate;
  animation-name: FadeIn2;
  animation-fill-mode: forwards;

  .content {
    position: absolute;
    top: -0.8rem;
    left: 0.35rem;
    width: 1.5rem;
    height: 1.3rem;
    border: 1px dashed yellow;
    border-radius: 10%;
    animation-delay: 1s;
    animation-duration: 1s;
    animation-direction: alternate;
    animation-name: FadeIn11;
    animation-fill-mode: forwards;
    transform: scaleX(0);
  }
}

.corn3 {
  position: absolute;
  top: 5.95rem;
  left: 4.3rem;
  width: 1.5rem;
  height: 0rem;
  opacity: 1;
  border: 0.01rem solid #00FEFF;
  border-radius: 1%;
  animation-duration: 1s;
  animation-direction: alternate;
  animation-name: FadeIn3;
  animation-fill-mode: forwards;

  .content {
    position: absolute;
    top: -0.1rem;
    left: -1.7rem;
    width: 1.5rem;
    height: 1.3rem;
    border: 1px dashed yellow;
    border-radius: 10%;
    animation-delay: 1s;
    animation-duration: 1s;
    animation-direction: alternate;
    animation-name: FadeIn11;
    animation-fill-mode: forwards;
    transform: scaleX(0);


  }
}

.corn4 {
  position: absolute;
  top: 4.5rem;
  left: 8.1rem;
  width: 1rem;
  height: 1rem;
  border-left: .03rem solid #00feff;
  border-top: .03rem solid #00feff;
  border-radius: 1%;
  animation-duration: 1s;
  animation-direction: alternate;
  animation-name: FadeIn4;
  animation-fill-mode: forwards;

  .content {
    position: absolute;
    top: -0.5rem;
    left: 1.1rem;
    width: 1.5rem;
    height: 1.3rem;
    border: 1px dashed yellow;
    border-radius: 10%;
    animation-delay: 1s;
    animation-duration: 1s;
    animation-direction: alternate;
    animation-name: FadeIn11;
    animation-fill-mode: forwards;
    transform: scaleX(0);

  }
}

.corn5 {
  position: absolute;
  top: 5rem;
  left: 1.9rem;
  width: 3.6rem;
  height: 0rem;
  opacity: 1;
  border: 0.01rem solid #00FEFF;
  border-radius: 1%;
  animation-duration: 1.5s;
  animation-direction: alternate;
  animation-name: FadeIn5;
  animation-fill-mode: forwards;

  .content {
    position: absolute;
    top: -0.5rem;
    left: -1.6rem;
    width: 1.5rem;
    height: 1.3rem;
    border: 1px dashed yellow;
    border-radius: 10%;
    animation-delay: 1s;
    animation-duration: 1s;
    animation-direction: alternate;
    animation-name: FadeIn11;
    animation-fill-mode: forwards;
    transform: scaleX(0);

   
  }
  
}
.txt {
      display: flex;
      margin-top: 5px;
      margin-left: 3px;

      span:nth-child(1) {
        color: #ffffff;
        font-size: 8px;
      }

      span:nth-child(2) {
        color: #01e0e3;
        font-size: 10px;
      }
    }
@keyframes FadeIn1 {
  0% {
    width: 0;
    height: 0;
  }

  30% {
    width: 0;
    height: 0.5rem;
  }

  70% {
    width: 0.6rem;
    height: 0.7rem;
  }

  100% {
    width: 1rem;
    height: 1rem;
  }

}

@keyframes FadeIn2 {
  0% {
    width: 0;
    height: 0;
  }

  30% {
    width: 0;
    height: 0.5rem;
  }

  70% {
    width: 0.15rem;
    height: 0.7rem;
  }

  100% {
    width: 0.3rem;
    height: 1rem;
  }

}

@keyframes FadeIn3 {
  0% {
    width: 0;
    height: 0;
  }

  30% {
    width: 0;
    height: 0;
  }

  70% {
    width: 0.8rem;
    height: 0;
  }

  100% {
    width: 1.5rem;
    height: 0;
  }

}

@keyframes FadeIn4 {
  0% {
    width: 0;
    height: 0;
  }

  30% {
    width: 0;
    height: 0.4rem;
  }

  70% {
    width: 0.5rem;
    height: 0.8rem;
  }

  100% {
    width: 1rem;
    height: 1rem;
  }

}

@keyframes FadeIn5 {
  0% {
    width: 0;
    height: 0;
  }

  30% {
    width: 0.5rem;
    height: 0;
  }

  50% {
    width: 1rem;
    height: 0;
  }

  60% {
    width: 1.5rem;
    height: 0;
  }

  60% {
    width: 2rem;
    height: 0;
  }

  80% {
    width: 2.5rem;
    height: 0;
  }

  90% {
    width: 3rem;
    height: 0;
  }

  100% {
    width: 3.6rem;
    height: 0;
  }

}

@keyframes FadeIn11 {
  0% {
    transform: scaleX(1) translateY(-15px);
  }

  30% {
    transform: scaleX(1) translateY(0px);
  }

  40% {
    transform: scaleX(1) translateY(-20px);
  }

  60% {
    transform: scaleX(1) translateY(0px);
  }

  80% {
    transform: scaleX(1) translateY(-15px);
  }

  100% {
    transform: scaleX(1) translateY(0px);
  }

}

@keyframes FadeIn {
  0% {
    transform: scaleX(0.3);
  }

  20% {
    transform: scaleX(0.6);
  }

  40% {
    transform: scaleX(0.9);
  }

  60% {
    transform: scaleX(1.1);
  }

  80% {
    transform: scaleX(0.9);
  }

  100% {
    transform: scaleX(1);
  }

}</style>
